var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVexaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microphone-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M20.25 12.2485V13.2485C20.25 17.6668 16.6683 21.2485 12.25 21.2485C7.83172 21.2485 4.25 17.6668 4.25 13.2485V12.2485M12.25 17.2485C10.0409 17.2485 8.25 15.4577 8.25 13.2485V7.24853C8.25 5.0394 10.0409 3.24854 12.25 3.24854C14.4591 3.24854 16.25 5.0394 16.25 7.24854V13.2485C16.25 15.4577 14.4591 17.2485 12.25 17.2485Z",
    stroke: "#9E77ED",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVexaLogo);
export default __webpack_public_path__ + "static/media/vexa-logo.ee784054c9d9623847f41fa984eabfdf.svg";
export { ForwardRef as ReactComponent };